import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BankSearchService {
  // constructor() {}

  // The reusable custom search function
  bankCustomSearchFn(term: string, item: any): boolean {
    const searchTerm = term.toLowerCase();
    return (
      item?.ibanNumber?.toLowerCase().includes(searchTerm) ||
      item?.name?.toLowerCase().includes(searchTerm) ||
      item?.accountCurrency?.code?.toLowerCase().includes(searchTerm)
    );
  }
}
